import React from "react";
import { useSelector } from "react-redux";

const API_BASE = `${process.env.REACT_APP_COLLEGE_ERP_API}`;

const BackupDownloadComponent = (token) => {
  const auth = useSelector((state) => state.authentication);
  const { userData } = auth;
  const handleDownload = async () => {
    try {
      const response = await fetch(`${API_BASE}download-backup`, {
        method: "GET",
        headers: {
          Accept: "application/octet-stream", // Set the expected file type (binary stream)
          Authorization: `Bearer ${userData.token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const blob = await response.blob(); // Convert response to blob (binary data)
      const url = window.URL.createObjectURL(blob); // Create object URL for download

      const link = document.createElement("a");
      link.href = url;
      link.download = "backup-file.tar.gz"; // Set the filename for the download
      link.click(); // Trigger the download

      window.URL.revokeObjectURL(url); // Cleanup the created URL
    } catch (error) {
      console.error("Error downloading the backup file:", error);
    }
  };

  return (
    <div>
      <button onClick={handleDownload}>Download Backup File</button>
    </div>
  );
};

export default BackupDownloadComponent;
